import { types } from "../types";

const initialState = { path: null };

function NavigationReducer(state = initialState, action) {
  switch (action.type) {
    case types.NavigationSuccess:
      return { ...state, path: action.path };
    case types.CLEAR_NAVIGATION:
      return { ...state, path: null };
    default:
      return state;
  }
}

export default NavigationReducer;